export const zhCnLocale = {
  model: {
    role: '角色'
  },
  role: {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    name: '名称',
    kind: '类型',
      kinds: {
        super: 'Super',
        application: '应用管理',
        custom: 'Custom',
      },
    customPermissions: '自定义权限',
  }
}

export const enLocale = {
  model: {
    role: 'Role'
  },
  role: {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    name: 'Name',
    kind: 'Kind',
      kinds: {
        super: 'Super',
        application: 'Application',
        custom: 'Custom',
      },
    customPermissions: 'Custom permissions',
  }
}

